import { ConfigEmployeeView } from './Employee';
import  CreateUpdateEmployee  from './CreateUpdate';

export { CreateUpdateEmployee };

export default ConfigEmployeeView;